const SearchMultisearchService = function SearchMultisearchService(Restangular, featureService, breakpointsService, $stateParams) {
    this._api = Restangular.one('Search');
    this.feature = featureService;
    this.breakpoints = breakpointsService;
    this._stateParams = $stateParams;
};

SearchMultisearchService.prototype.updateMultisearchItems = function (multisearchItems) {
    return this._api.one('Multisearch').doPOST({ MultisearchKeys: multisearchItems }).then(function (response) {
        return response.MultisearchItems;
    });
};

SearchMultisearchService.prototype.multisearchEnabled = function () {
    if (this.breakpoints.isInSmallFormat) {
        return this.feature.isEnabled(this.feature.features.multisearchSf);
    }
    return this.feature.isEnabled(this.feature.features.multisearch);

};

SearchMultisearchService.prototype.isSearchTermPartOfMultisearchList = function (searchTerm, multisearchItems) {
    if (!this._stateParams.multisearchItems && !multisearchItems) {
        return false;
    }
    if (!this._stateParams.searchTerm && !searchTerm) {
        return false;
    }

    const searchPhrase = searchTerm ? searchTerm : this._stateParams.searchTerm;
    const items = multisearchItems ? multisearchItems.split(',') : this._stateParams.multisearchItems.split(',');
    const listIndex = items.indexOf(searchPhrase);
    if (listIndex < 0) {
        return false;
    }

    return true;
};

SearchMultisearchService.prototype.isSearchMultisearch = function () {
    return this._stateParams.multisearchItems && this.isSearchTermPartOfMultisearchList() && this.multisearchEnabled();
};

module.exports = SearchMultisearchService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-multisearch-service.js
 **/